import React from 'react';
import { arrowDownLine, arrowUpLine, Icone } from "../../../fondamentaux/Icone";
import { TABLEAU_ORDRE_TRI_ASC, TABLEAU_ORDRE_TRI_DESC } from "../index";
var TableauHeaderCell = function (_a) {
    var children = _a.children, scope = _a.scope, ordreTri = _a.ordreTri, onClick = _a.onClick;
    if (onClick) {
        var handleKeyDown = function (event) {
            if (onClick && (event.key === 'Enter' || event.key === '13')) {
                onClick();
            }
        };
        return (React.createElement("th", { scope: scope, onClick: function () { return onClick(); }, style: { cursor: 'pointer' }, role: "button", onKeyDown: handleKeyDown, tabIndex: 0 },
            children,
            ordreTri === TABLEAU_ORDRE_TRI_ASC ? (React.createElement(Icone, { icone: arrowUpLine })) : null,
            ordreTri === TABLEAU_ORDRE_TRI_DESC ? (React.createElement(Icone, { icone: arrowDownLine })) : null));
    }
    return (React.createElement("th", { scope: scope },
        children,
        ordreTri === TABLEAU_ORDRE_TRI_ASC ? (React.createElement(Icone, { icone: arrowUpLine })) : null,
        ordreTri === TABLEAU_ORDRE_TRI_DESC ? (React.createElement(Icone, { icone: arrowDownLine })) : null));
};
export default TableauHeaderCell;
